import { render, staticRenderFns } from "./CallerPeer.vue?vue&type=template&id=4aad988b&"
import script from "@/scripts/CallerPeer.js?vue&type=script&lang=js&"
export * from "@/scripts/CallerPeer.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports